<template>
  <div class="taskClock-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="97px" size="small">
      <div class="white-container">
        <el-form-item label="第一行标题" prop="title" style="width: 416px">
          <el-input v-model="form.title" maxlength="11" placeholder="请输入任务标题，最多不超过11个字符" />
        </el-form-item>
        <el-form-item label="第二行标题" prop="subTitle" style="width: 416px">
          <el-input v-model="form.subTitle" maxlength="11" placeholder="请输入任务标题，最多不超过11个字符" />
        </el-form-item>
        <el-form-item label="专题介绍" prop="introduction" style="width: 851px">
          <el-input v-model="form.introduction" type="textarea" :rows="5" :disabled="disabled" />
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传视频" prop="mediaLink" class="video-wrap">
          <div class="coupon-upload flex">
            <el-upload ref="uploader" class="xls-uploader" action="" accept="video/*" :show-file-list="false" :on-change="upLoadVideo" :auto-upload="false">
              <el-button v-if="form.mediaLink" size="small" type="primary">重新上传</el-button>
              <el-button v-else size="small" type="primary">上传文件</el-button>
            </el-upload>
            <el-progress v-if="
              uploadProgress != 0 &&
                uploadProgress != 100 &&
                uploadProgressStatus
            " class="progress-cont" :text-inside="true" :stroke-width="16" :percentage="uploadProgress"
            />
            <div class="upload_tips" style="margin-left: 15px;">
              仅支持上传*.mov、*.mp4格式, 大小不超过100MB
            </div>
            <div v-if="form.mediaLink" class="download-file">
              <video id="player-container" ref="customVideo" :src="form.mediaLink" class="custom-video" preload="auto" controls playsinline webkit-playsinline />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="上传图片" prop="classImage" class="image-config" label-width="78px">
          <div class="flex uploadImg-cont" style="flex-wrap: wrap">
            <UploadImage :url="form.classImage.headImg" title="课程集合页头图" size-tips="1125px*1125px" :save-path="savePath" :disabled="disabled" @upload="uploaderImage($event,'headImg')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.classImage.shareCardImg" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" :save-path="savePath" :disabled="disabled" @upload="uploaderImage($event,'shareCardImg')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.classImage.shareImg" title="课程集合页长图分享图片" size-tips="849px*849px" :save-path="savePath" :disabled="disabled" @upload="uploaderImage($event,'shareImg')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="配置课程" prop="courses" class="classRecommend" label-width="78px">
          <div class="flex">
            <el-input v-model="searchClassName" placeholder="请输入课程名称" style="width:258px" />
            <el-button type="primary" @click="searchClassSubmit">查询</el-button>
            <el-button @click="resetClass">重置</el-button>
          </div>
          <el-table ref="multipleTable1" size="small" :data="searchClassList" style="margin-top:30px">
            <el-table-column prop="id" label="课程ID" align="center" />
            <el-table-column prop="name" label="课程标题" align="center" />
            <el-table-column label="操作" fixed="right" align="center">
              <template v-slot="{row}">
                <el-button size="small" type="text" class="link-color" @click="addClass(row)">添加</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="addClassTitle">已添加课程</div>
          <el-table ref="multipleTable2" size="small" :data="classList">
            <el-table-column prop="id" label="课程ID" align="center" />
            <el-table-column prop="title" label="课程标题" align="center" />
            <el-table-column fixed="right" label="操作" align="center">
              <template v-slot="{row}">
                <el-button size="small" type="text" class="link-color" @click="removeClass(row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item style="width:100%;margin-top:80px;">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSave">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { curriculumCollectionManagement } from '@/model/curriculumCollectionManagement';
import Dialog from '@/components/Dialog';
import UploadImage from '@/components/UploadImage';
import { getFileType } from "@/common/js/util";
export default {
  components: { Dialog, UploadImage },
  data() {
    return {
      disabled: false,
      savePath: 'curriculumCollectionManagement/detail/',
      form: new curriculumCollectionManagement(),
      rules: {
        title: [
          { required: true, message: '请输入任务标题，最多不超过11个字符', trigger: 'blur' },
        ],
        introduction: [
          { required: true, message: '请输入专题介绍', trigger: 'blur' },
        ],
        classImage: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'headImg', label: '课程集合页头图' },
              { key: 'shareCardImg', label: '小程序分享卡片' },
              { key: 'shareImg', label: '课程集合页长图分享图片' },
            ];
            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },
        courses: [
          { type: 'array', required: true, message: "请选择课程", trigger: ["blur"] },
        ],
      },
      formDialogShow: false,
      information: {},
      mediaLink: '',
      uploadProgress: 0, // 视频上传的进度
      uploadProgressStatus: false,
      searchClassName: '',
      searchClassList: [],
      classList: [],
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    const { query } = this.$route;
    this.id = query.id;
    this.cancelText = query.id ? '编辑' : '新增';
    if (query.id) {
      this.getEditDetail(this.id);
    }
  },
  methods: {
    /** 编辑回显详情数据 */
    getEditDetail(id) {
      this.$Api.curriculumCollectionManagement.courseCollectionPageDetail(id).then(res => {
        this.form = new curriculumCollectionManagement(res);
        this.classList = res.courses;
      });
    },
    /** 根据名称查询课程 */
    searchClassSubmit() {
      if (!this.searchClassName) return this.$message.warning("请先输入课程名称!");
      this.$Api.taskClock.taskCourseSelect(this.searchClassName).then(res => {
        this.searchClassList = res;
        if (this.classList && this.classList.length) {
          this.updateClassIdAndList();
        }
      });
    },
    /** 重置课程 */
    resetClass() {
      this.searchClassName = '';
      this.searchClassList = [];
    },
    /** 添加课程 */
    addClass(row) {
      const item = this.searchClassList.find(item => item.id === row.id);
      if (item) {
        this.classList.push({ title: item.name, ...item });
        this.updateClassIdAndList();
        this.$refs.form.validateField('courses');
      }
    },
    /** 删除课程 */
    removeClass(row) {
      const index = this.classList.findIndex(item => item.id === row.id);
      if (index !== -1) {
        const removedItem = this.classList.splice(index, 1)[0];
        this.updateClassIdAndList(removedItem.id);
      }
    },
    /** 更新form.courses字段中的id */
    updateClassIdAndList(removedId = null) {
      this.form.courses = this.classList.map((item) => { return item.id; });
    },
    handleCheckReg() {
      this.$refs.form.validateField("classImage");
    },
    uploaderImage(file, key) {
      this.form.classImage = {
        ...this.form.classImage,
        [key]: file,
      };
    },
    // 上传视频
    upLoadVideo(file) {
      const _this = this;
      const type = getFileType(file.name);
      if (type !== "video") {
        this.$message.error('视频格式不正确');
        this.$refs.uploader.clearFiles();
        return;
      }
      if (parseFloat(file.raw.size / 1024 / 1024) > 100) {
        this.$message.error(`视频大小不能超过100MB`);
        this.$refs.uploader.clearFiles();
        return;
      }
      _this.uploadProgressStatus = true;
      _this.$Api.uploadFile.putCloudDemandUpload({
        mediaFile: file.raw,
        onUploadProgress: progressEvent => {
          const process =
            parseInt((progressEvent.loaded / progressEvent.total) * 100) || 0;
          console.log('process', process);
          _this.uploadProgress = process;
        },
      }).then(res => {
        _this.uploadProgressStatus = false;
        this.form.videoIntroduction = res.fileId;
        this.form.mediaLink = res.mediaUrl;
      }).catch(_ => {
        _this.uploadProgress = 0;
        _this.uploadProgressStatus = false;
        _this.$message.error("上传失败！");
      });
    },
    /** 取消 */
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: "cancel",
        icon: "warn",
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    /** 保存 */
    handleSave() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: `请注意课程集合页状态，保存后已发布的课程集合页信息将实时更新至UA HOUSE小程序`,
      };
    },
    /** 弹窗信息回调 */
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'cancel') {
        this.$router.back(-1);
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.form.id) {
              this.updateDetail();
            } else {
              this.createDetail();
            }
          } else {
            return false;
          }
        });
      }
    },
    /** 新增 */
    createDetail() {
      this.updateClassIdAndList();
      const { classImage, ...otherFields } = this.form;
      const params = {
        ...classImage,
        ...otherFields,
      };
      this.$Api.curriculumCollectionManagement.courseCollectionPageAdd(params).then(() => {
        this.$message.success("新增成功");
        this.$router.go(-1);
      });
    },
    /** 编辑 */
    updateDetail() {
      this.updateClassIdAndList();
      const { classImage, ...otherFields } = this.form;
      const params = {
        ...classImage,
        ...otherFields,
      };
      this.$Api.curriculumCollectionManagement.courseCollectionPageEdit(params).then(() => {
        this.$message.success("修改成功");
        this.$router.go(-1);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.progress-cont {
  margin-left: 15px;
  width: 300px;
  margin-top: 8px;
}
.marginTop {
  margin-top: 20px;
}
.btns {
  margin-left: -100px;
  align-items: center;
  justify-content: center;
  >button{
    width: 120px;
    height: 50px;
    border-radius: 4px;
    font-size: 16px;
  }
}

.image-config{
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  /deep/.el-form-item__label-wrap{
    margin-bottom: 20px;
  }
  /deep/.el-form-item__content {
    margin-left: 0!important;
  }
}

.classRecommend {
  display: flex;
  flex-direction: column;
  /deep/.el-form-item__content {
    margin-top: 30px;
    margin-left: 0!important;
  }
}

.addClassTitle {
  color: #999999;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin: 30px 0 15px;
}

.coupon-upload {
  flex-wrap: wrap;
  .download-file {
    flex-basis: 100%;
    margin-top: 20px;
    .custom-video {
      width: 266px;
      height: 150px;
    }
  }
}

.upload_tips{
  font-size: 12px;
  color: #BBBBBB;
}

:deep(.video-wrap) {
  margin-bottom: 60px;
  .el-form-item__label {
    float: none;
  }
  .el-form-item__content {
    margin-top: 20px;
    margin-left: unset !important;
  }
}
</style>
